import { useNavigate } from "react-router-dom"
import { PATH_MAP } from "../configuration/PathMap"

const useControllerNavegation = () => {
  const navigate = useNavigate()

  const goToHome = () => {
    navigate(PATH_MAP.ROOT_PAGE)
  }

  const goToPage = (path: string) => {
    navigate(path)
  }

  return {
    goToHome,
    goToPage,
  }
}

export default useControllerNavegation
